import { USER_MANUAL_URL } from '../const'

export const openUserManual = () => {
  const manualWindow = window.open(USER_MANUAL_URL, '_blank', 'noopener,noreferrer')

  if (manualWindow) {
    manualWindow.opener = null
  }
}
